import Type from "@/model/types/Type";

const type = {

    IN: 1,
    OUT: 2,

}

const list = [
    {
        value: type.IN,
        text: "Entrada",
    },
    {
        value: type.OUT,
        text: "Saída",
    },
]

const contains = function (type) {
    return Type.contains(list, type)
}

const getText = function (type) {
    return Type.getText(list, type)
}

export default {
    type,
    list,
    contains,
    getText
}


